import { forwardRef } from 'react';
import { ChatFilterButton as GenericFilterButton } from '@trinity/chat-components/components/FilterButton/index.js';

type Props = {
  onClick?: () => void;
  disabled?: boolean;
  filtersCount?: number;
};

export const ChartFilterButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  return (
    <GenericFilterButton
      ref={ref}
      variant="chart"
      onClick={props.disabled ? undefined : props.onClick}
      disabled={props.disabled}
      count={props.filtersCount}
      aria-label="Chart Filter" />
  );
});

ChartFilterButton.displayName = 'ChartFilterButton';